<template>
  <v-autocomplete
      hide-details="auto"
      :items="dishes"
      :loading="loadingDishes"
      v-model="selectedDish"
      item-text="name"
      item-value="id"
      label="Dish"
      outlined
      dense
      @change="emitInput"
      clearable
      :search-input.sync="searchDishes"
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dishes: [],
    selectedDish: null,
    searchDishes:null,
    loadingDishes:false,
  }),
  methods: {
    emitInput() {
      this.$emit("input", this.selectedDish);
    },
  getdishesByQuery(query = "") {
    this.loadingDishes = true;
    this.$store
        .dispatch("dish/GetDishSearch", {
          query: query,
        })
        .then((res) => {
          this.dishes = res;
          this.loadingDishes = false;
        })
        .catch((err) => {
          this.loadingDishes = false;
          this.messages = err.data.title;
        });
  },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedDish = null;
      },
      deep: true,
    },
    searchDishes: {
      handler(val) {
        this.getdishesByQuery(val);
      },
      deep: true,
    },
  },
  created(){
    this.getdishesByQuery()
  }
};
</script>